<script lang="ts">
	import Icon from '../Icon.svelte';
	import IconButton from '../buttons/IconButton.svelte';

	interface Props {
		header: string;
		minWidth?: number;
		maxWidth?: number;
		mobile?: boolean;
		content?: import('svelte').Snippet;
		onModalClose: () => void;
	}

	let {
		header,
		minWidth = 360,
		maxWidth = 360,
		mobile = false,
		content,
		onModalClose
	}: Props = $props();

	let modal = $state();

	let left = $derived(mobile ? 0 : window.innerWidth - maxWidth - 20);
	let top = $derived(mobile ? 0 : 120);

	let offsetY = 0;
	let offsetX = 0;

	function handleDragStart(event: DragEvent | TouchEvent) {
		if (mobile) return;

		const grabbed = event.currentTarget as HTMLElement;

		let clientX = 0;
		let clientY = 0;

		if (event instanceof DragEvent) {
			clientX = event.clientX;
			clientY = event.clientY;
		} else if (event instanceof TouchEvent) {
			if (event.targetTouches?.length == 1) {
				var touch = event.targetTouches[0];

				clientX = touch.clientX;
				clientY = touch.clientY;
			}
		}

		offsetX = grabbed?.getBoundingClientRect().x - clientX;
		offsetY = grabbed?.getBoundingClientRect().y - clientY;

		//Remember the mouse movement
		left = clientX + offsetX;
		top = clientY + offsetY;
	}

	function handleDrag(event: DragEvent | TouchEvent) {
		if (mobile) return;

		let clientX = 0;
		let clientY = 0;

		if (event instanceof DragEvent) {
			clientX = event.clientX;
			clientY = event.clientY;
		} else if (event instanceof TouchEvent) {
			if (event.targetTouches?.length == 1) {
				//Prevent scrolling of the web view
				event.preventDefault();

				var touch = event.targetTouches[0];

				clientX = touch.clientX;
				clientY = touch.clientY;
			}
		}

		//Remember the mouse movement
		left = clientX + offsetX;
		top = clientY + offsetY;
	}
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	ondragover={handleDrag}
	ontouchmove={handleDrag}
	class="modal-container"
	class:h-full={mobile}
	class:w-full={mobile}
>
	<!--content-->
	<div
		bind:this={modal}
		class="rounded-md absolute flex flex-col shadow-2xl border-2 border-gray dark:border-gray overflow-y-auto"
		class:h-full={mobile}
		class:w-full={mobile}
		style="left: {left}px; top: {top}px; {mobile
			? ''
			: `width: ${minWidth}px; max-width:${maxWidth}px;`}"
	>
		<div
			class="bg-background dark:bg-dark-200 dark:border-dark-200 p-2 flex gap-4 rounded-t-2xl items-center cursor-move"
			draggable={true}
			ontouchstart={handleDragStart}
			ondragstart={handleDragStart}
		>
			<Icon name="ellipsis-v" size="small" classInfo="dark:fill-white" />
			<p class="grow text-sm font-bold uppercase text-darkgray dark:text-white">{header}</p>
			<IconButton
				iconName="xmark"
				size="small"
				onClick={() => {
					onModalClose();
				}}
			/>
		</div>

		{@render content?.()}
	</div>
</div>

<style>
	.modal-container {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 90;
	}
</style>
